import { useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { waLink } from "@/lib/whatsapp";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const { settings } = useApp();
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = () => {
    if (!form.name || !form.message) return toast.error("Please fill in your name and message");
    api.post("/enquiries", { type: "contact", ...form }).then(() => { toast.success("Message sent! We'll get back to you soon."); setForm({ name: "", phone: "", email: "", message: "" }); });
  };
  return (
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10 lg:py-14">
      <h1 className="font-heading text-4xl lg:text-5xl text-forest tracking-tight text-center">Get in Touch</h1>
      <p className="text-brown/70 mt-3 text-center max-w-xl mx-auto">Questions about products, orders or wellness advice? We're here to help.</p>
      <div className="grid lg:grid-cols-2 gap-8 mt-10">
        <div className="bg-white rounded-[28px] soft-shadow p-7">
          <h3 className="font-heading text-2xl text-forest mb-4">Send us a message</h3>
          <div className="space-y-3">
            <div><Label className="text-sm">Name *</Label><Input value={form.name} onChange={set("name")} className="rounded-xl bg-sand" data-testid="contact-name" /></div>
            <div className="grid sm:grid-cols-2 gap-3">
              <div><Label className="text-sm">Phone</Label><Input value={form.phone} onChange={set("phone")} className="rounded-xl bg-sand" data-testid="contact-phone" /></div>
              <div><Label className="text-sm">Email</Label><Input value={form.email} onChange={set("email")} className="rounded-xl bg-sand" data-testid="contact-email" /></div>
            </div>
            <div><Label className="text-sm">Message *</Label><Textarea value={form.message} onChange={set("message")} rows={4} className="rounded-xl bg-sand" data-testid="contact-message" /></div>
            <Button onClick={submit} className="w-full rounded-full h-12 bg-forest hover:bg-earth text-cream" data-testid="contact-submit">Send Message</Button>
          </div>
        </div>
        <div className="space-y-4">
          {[[MapPin, "Address", settings.address || "New Delhi, India"], [Mail, "Email", settings.email || "hello@liveneatorganic.com"], [Phone, "Phone", settings.phone || "+91 85956 72124"]].map(([Ic, t, v], i) => (
            <div key={i} className="bg-white rounded-2xl soft-shadow p-5 flex items-center gap-4">
              <span className="w-12 h-12 rounded-2xl bg-sage/20 flex items-center justify-center"><Ic className="w-5 h-5 text-forest" /></span>
              <div><div className="text-sm text-olive font-500">{t}</div><div className="text-ink">{v}</div></div>
            </div>
          ))}
          <a href={waLink(settings.whatsapp_number, "Hi LIVENEAT Organic!")} target="_blank" rel="noreferrer" data-testid="contact-wa-btn"
            className="bg-[#25D366] rounded-2xl p-5 flex items-center gap-4 text-white hover:bg-[#1eb85a] transition-colors">
            <span className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center"><MessageCircle className="w-5 h-5" /></span>
            <div><div className="text-sm font-500">Chat on WhatsApp</div><div className="text-white/90">Fastest way to reach us</div></div>
          </a>
        </div>
      </div>
    </div>
  );
}
